document.addEventListener("DOMContentLoaded", function() {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const categoryCheckboxes = document.querySelectorAll(".category-checkbox");
  const modalidadCheckboxes = document.querySelectorAll(".modalidad-checkbox");
  
  // Filtrar por Colección (Cursos Nuevos, Cursos en Oferta)
  filterButtons.forEach(button => {
    button.addEventListener("click", function() {
      const filterValue = button.getAttribute("data-filter");
      filterProductsByCollection(filterValue);
    });
  });

  // Filtrar por Modalidad (Virtual, Presencial)
  modalidadCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("change", function() {
      const selectedModalities = getSelectedModalities();
      filterProductsByModalidad(selectedModalities);
    });
  });

  // Filtrar por Categoría de Curso (Gestión y Negocios, etc.)
  categoryCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("change", function() {
      const selectedCategories = getSelectedCategories();
      filterProductsByCategory(selectedCategories);
    });
  });

  function getSelectedModalities() {
    const selectedModalities = [];
    modalidadCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selectedModalities.push(checkbox.getAttribute("data-category"));
      }
    });
    return selectedModalities;
  }

  function getSelectedCategories() {
    const selectedCategories = [];
    categoryCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selectedCategories.push(checkbox.getAttribute("data-category"));
      }
    });
    return selectedCategories;
  }

  function filterProductsByCollection(filterValue) {
    const products = document.querySelectorAll(".grid__item");
    products.forEach(product => {
      if (filterValue === "new-courses" && !product.classList.contains("new-course")) {
        product.style.display = "none";
      } else if (filterValue === "offer-courses" && !product.classList.contains("offer-course")) {
        product.style.display = "none";
      } else if (filterValue === "modalidad" && !product.classList.contains("modalidad")) {
        product.style.display = "none";
      } else {
        product.style.display = "block";
      }
    });
  }

  function filterProductsByModalidad(modalities) {
    const products = document.querySelectorAll(".grid__item");
    products.forEach(product => {
      const productModalities = product.getAttribute("data-category").split(" ");
      const matches = modalities.some(modality => productModalities.includes(modality));
      if (matches) {
        product.style.display = "block";
      } else {
        product.style.display = "none";
      }
    });
  }

  function filterProductsByCategory(categories) {
    const products = document.querySelectorAll(".grid__item");
    products.forEach(product => {
      const productCategories = product.getAttribute("data-category").split(" ");
      const matches = categories.some(category => productCategories.includes(category));
      if (matches) {
        product.style.display = "block";
      } else {
        product.style.display = "none";
      }
    });
  }
});
